// extracted by mini-css-extract-plugin
export default {"styles":"styles____fl7L","emptyPrompt":"emptyPrompt___bC_YF"};